<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
    id: Number,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Stores
const componentsStore = useComponentsStore()
const itemDataStore = useItemDataStore()

// Local Reactive State
const item = ref(undefined)

// Computed Properties
const tableName = computed(() => viewStore.tableName)

const componentId = computed(() => {
    return tableName.value ? componentsStore.componentIds[tableName.value] : undefined
})

const nameField = computed(() => {
    return componentId.value ? componentsStore.nameField(componentId.value) : undefined
})

// Native watcher replacing useAsyncState for item fetching
watch(
    () => [tableName.value, props.id],
    async ([newTable, newId]) => {
        if (!newTable || !newId) {
            item.value = undefined
            return
        }

        item.value = await itemDataStore.get({
            tableName: newTable,
            id: newId
        })
    },
    {immediate: true}
)

const title = computed(() => {
    if (item.value && nameField.value) {
        return item.value[nameField.value]
    }
    return ''
})
</script>

<template>
    <span v-html="title"/>
</template>